import { FormField, FormItem, FormLabel } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function InputFormField({ form }: { form: UseFormReturn<FormValues> }) {
  const { t } = useTranslation();
  return (
    <FormField
      control={form.control}
      name="titel"
      render={({ field }) => (
        <FormItem className="w-full">
          <FormLabel>
            {t('domain.termine.sheet.fields.titel')}
            <span>*</span>
          </FormLabel>
          <Input {...field} onChange={field.onChange} autoComplete="off" />
        </FormItem>
      )}
    />
  );
}
